import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(85vh - 50px); // Subtraindo o padding do modal
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 8px; // Espaço para a scrollbar
  margin-right: -8px; // Compensar o padding para alinhamento
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px 24px 0 24px; // Padding top e lateral, sem bottom
`;

export const FixedFooter = styled.div`
  padding: 16px 24px 24px 24px; // Padding para alinhar com o conteúdo
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FormContainer = styled.div`
  margin-bottom: 20px;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`;

export const FormField = styled.div`
  flex: 1;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
`;

export const SummaryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-weight: bold;
`;

